import { ChevronPrimary } from './ChevronPrimary';
import { English } from './languages/English';
import { German } from './languages/German';
import { Russian } from './languages/Russian';

export const Icons = {
  English,
  German,
  Russian,
  ChevronPrimary,
};
